import React from 'react';

import { useSixCatalogPage } from '@/hooks/sixCatalog/useSixCatalogPage';
import SixCatalogPageView from '@/pages/SixCatalogPage/SixCatalogPageView';

function SixCatalogPage(): React.ReactElement {
  const { state, handlers } = useSixCatalogPage();

  return (
    <SixCatalogPageView
      searchValue={state.searchValue}
      selectedSortKey={state.selectedSortKey}
      sortedSixes={state.sortedSixes}
      showEmptyState={state.showEmptyState}
      sortOptions={state.sortOptions}
      connectionStatusBySixId={state.connectionStatusBySixId}
      ownershipBySixId={state.ownershipBySixId}
      onSearchChange={handlers.handleSearchChange}
      onSearchClear={handlers.handleSearchClear}
      onSortChange={handlers.handleSortChange}
      onCardClick={handlers.handleCardClick}
      onToggleFavorite={handlers.handleToggleFavorite}
      onEdit={handlers.handleEdit}
      onDelete={handlers.handleDelete}
    />
  );
}

export default SixCatalogPage;
